'use client';

import { cn } from '@/shared/lib/cn';

/**
 * ONE default type size for a whole settings surface — the settings list AND
 * every drill-down sub-panel inside it.
 *
 * The page base is 18px on phones, so any element that doesn't name a role
 * inherits a size two tiers above the rows around it; this class makes the row
 * size the floor, and an explicit role class on a child still wins. Every
 * settings surface (render inspector, estimate, album) applies it — the render
 * panel had it and the estimate/album panels didn't, which is how they drifted
 * a tier apart. Parity with Apple `settingsSurface(_:)` and Android
 * `SettingsDisplayProvider`.
 */
export const SETTINGS_SURFACE_CLASS = 'text-settings-row-title';

/**
 * Layout-neutral (`display: contents`) declaration of a settings surface, for
 * hosts that return a fragment and have no root box of their own to put
 * {@link SETTINGS_SURFACE_CLASS} on. Inherited properties (font size) still
 * pass through to the children.
 */
export function SettingsSurface({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('contents', SETTINGS_SURFACE_CLASS, className)}>
      {children}
    </div>
  );
}
